import addUsers from './AddUsers/AddUsers.vue';
import editUsers from './EditUsers/EditUsers.vue';
import moment from 'moment';
import Swal from 'sweetalert2'
export default {
    name: 'AddUser',
    created(){
        this.getUser();
        this.loginDetails = localStorage.getItem('currentUser-client');
        if (this.loginDetails != "null" && this.loginDetails != null && this.loginDetails != "" && this.loginDetails != "[object Object]") {
            this.loginDetails = JSON.parse(this.loginDetails);
            if (this.loginDetails.userType != 1 && this.loginDetails.userType != 4) {
                window.location.href = "/Login";
            } 
          
        } else {
            window.location.href = "/Login";
        }
        this.GetOffices();
    },
    components: {
        'add-Users': addUsers,
        'edit-Users': editUsers
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            OfficeId:"",
            Offices:[],
            loginDetails:[],
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            users: [],

            EditUsersObj: [],
        };
    },
    methods: {

        DeleteUser(UserId) { 
            this.$confirm('سيؤدي ذلك إلى حدف المستخدم  . استمر؟', 'تـحذير', {
                confirmButtonText: 'نـعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {
                this.$blockUI.Start();
                this.$http.DeleteUser(UserId)
                    .then(() => {
                        this.$blockUI.Stop();
                        if (this.users.lenght === 1) {
                            this.pageNo--;
                            if (this.pageNo <= 0) {
                                this.pageNo = 1;
                            }
                        }
                        this.$notify({
                            title: 'تم حدف المستخدم بنجاح',
                            dangerouslyUseHTMLString: true,
                            // message: '<strong>' + response.data + '</strong>',
                            type: 'success'
                        });
                        this.getUser(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$message({
                            type: 'error',
                            message: err.response.data
                        });
                    });
            });

        },

        GetOffices() {
            this.$blockUI.Start();
            this.$http.GetOffice().then(response => {
                this.$blockUI.Stop();
                this.Offices = response.data.offices;
            })
                .catch(error => {
                    this.$blockUI.Stop();
                    Swal.fire(error.response.data, 'error')
                })
        },

        getUser(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }
            debugger;
            this.$blockUI.Start();
          
            this.$http.getUser(this.pageNo, this.pageSize, this.OfficeId)//this.$parent.SuperPackageParent.superPackageId
                .then(response => {
                    this.$blockUI.Stop();
                    this.users = response.data.users;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    // console.error(err);
                    this.pages = 0;
                });

        },

        addUser() {
            this.state = 1;
        },

        EditUser(User) {
            this.state = 2;
            this.EditUsersObj = User;

        },
        Confirm(Id) {
            Swal.fire({
                title: 'هل حـقا تريد اعتمـاد بيانات المستخدم؟',
                text: "سيتم قبول المستخدم قبولا نهائيـا",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'رجـوع',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'اسـتمر,نعم'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ConfirmUser(Id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'تم قبول المستخدم بنجاح',
                                dangerouslyUseHTMLString: true,
                                message: '<strong>' + response.data + '</strong>',
                                type: 'success'
                            });
                            this.getUser(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$message({
                                type: 'error',
                                message: err.response.data
                            });
                        });
                }
            });
        },
        ResendEmail(Id) {
            Swal.fire({
                title: 'هل حـقا تريد اعادة ارسال البريد الالكتروني للمستخدم؟',
                text: "سيتم  ارسال رسالة ",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'رجـوع',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'اسـتمر,نعم'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResendEmail(Id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'تم ارسال رسالة بنجاح',
                                dangerouslyUseHTMLString: true,
                                message: '<strong>' + response.data + '</strong>',
                                type: 'success'
                            });
                            this.getUser(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$message({
                                type: 'error',
                                message: err.response.data
                            });
                        });
                }
            });
        },

        DeactivateUser(UserId) {


            this.$confirm('سيؤدي ذلك إلى ايقاف تفعيل المستخدم  . استمر؟', 'تـحذير', {
                confirmButtonText: 'نـعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {


                this.$http.DeactivateUser(UserId)
                    .then(() => {
                        if (this.users.lenght === 1) {
                            this.pageNo--;
                            if (this.pageNo <= 0) {
                                this.pageNo = 1;
                            }
                        }
                        this.$message({
                            type: 'info',
                            message: 'تم ايقاف التفعيل المستخدم بنجاح',
                        });
                        this.getUser();
                    })
                    .catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data
                        });
                    });
            });
        },

        ActivateUser(UserId) {

            this.$confirm('سيؤدي ذلك إلى تفعيل المستخدم  . استمر؟', 'تـحذير', {
                confirmButtonText: 'نـعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {


                this.$http.ActivateUser(UserId)
                    .then(() => {
                        if (this.users.lenght === 1) {
                            this.pageNo--;
                            if (this.pageNo <= 0) {
                                this.pageNo = 1;
                            }
                        }
                        this.$message({
                            type: 'info',
                            message: 'تم تفعيل المستخدم بنجاح',
                        });
                        this.getUser();
                    })
                    .catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data
                        });
                    });
            });

        },
    }
}
